import { Templates } from '../../compile';
import { ModalOptions } from '../../interfaces/options/modal';

export const DefaultModalOptions: ModalOptions = {
	contentTemplate: Templates.general_empty,
	height: 'auto',
	template: Templates.modal_base,
	width: '50%'
};
